import withNavigate from "../../../routes/withNavigate";
import CandidateManagerContainer from "./CandidateManagerContainer.jsx";
import CandidateManagerStore from "./CandidateManagerStore";

export default CandidateManagerStore(withNavigate(CandidateManagerContainer));